import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Title } from '@angular/platform-browser';

import { SearchResult } from '../../_models/index';
import { BackendSearchService, SearchResultService, StructureService } from '../../_services/index';

@Component({
  selector: 'search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css']
})
export class SearchBoxComponent implements OnInit {
    searchQuery: string = '';

    // Change if the order of the search tabs change.
    textSearch_tabIdx: number = 0;
    structSearch_tabIdx: number = 1;
    selectedTab: number = this.textSearch_tabIdx;

  constructor(    
    public searchSvc: BackendSearchService,
    private searchResultService: SearchResultService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private structSvc: StructureService
  ) {
    this.route.queryParams.subscribe(
      params => {
        // Launch text-based query
        if (params['query'] && 'type' in params && (params['type'] === 'string' || params['type'] === 'substructure')) {
          this.searchQuery = params['query'];

          this.searchSvc.search(this.searchQuery, params['type']).subscribe(
            (resuults: SearchResult) => {
              this.searchResultService.announceNewSearchResult(resuults);
            },
            (err: any) => {
              this.catchError(err);
            }
          );
        }

        // Update the structure and get the molfile returned
        if (params['query'] && 'type' in params && (params['type'] === 'structure' || params['type'] === 'substructure')) {
          this.searchQuery = params['query'];
          this.structSvc.announceSmiles(this.searchQuery);
          this.structSvc.getMolfile(this.searchQuery);
          if (params['type'] === 'substructure') {
            this.structSvc.announceMode('substructure');
          } else {
            this.structSvc.announceMode(params['mode']);
          }
        }

        // Launch Tanimoto similarity search
        if (params['query'] && 'tanimoto' in params) {
          this.structSvc.announceTanimoto(params['tanimoto']);

          this.searchSvc.searchSimilarity(this.searchQuery, params['tanimoto'], params['category'])
            .subscribe(
              (results: SearchResult) => {
                this.searchResultService.announceNewSearchResult(results);
              },
              (err: any) => {
                this.catchError(err);
              }
            );
        }

        // Launch Exact and stereo-free structure matches
        if (params['query'] && 'type' in params && params['type'] === 'structure' && (params['mode'] === 'exact' || params['mode'] === 'stereofree')) {
          this.searchSvc.searchStructExact(this.searchQuery, params['mode'], params['category'])
            .subscribe(
              (results: SearchResult) => {
                this.searchResultService.announceNewSearchResult(results);
              },
              (err: any) => {
                this.catchError(err);
              }
            );
        }

      }
    );
  }

  catchError(err: any){
    this.searchResultService.announceNewSearchResult(new SearchResult(err));
  }


  // when changing between tabs, reset (delete) the search parameters
  resetInput(event) {
    this.structSvc.announceMode('exact');
    this.structSvc.announceTanimoto(0.85);
    this.structSvc.announceSmiles('');
    this.structSvc.announceMolFile('');
    this.searchQuery = '';
    // this.searchResultService.announceSubmit(false);

    let search_type: string;

    // make sure the tab is set to the correct search mode.
    if (event.index === this.textSearch_tabIdx) {
      search_type = "string";
    } else if (event.index === this.structSearch_tabIdx) {
      search_type = "structure"
    }

    // reset page title
    this.titleService.setTitle("reframeDB");

    // reset the route to the search or structure page, sans any input
    this.router.navigate(['search/'], { queryParams: { type: search_type } });
  }
  
  ngOnInit() {
    this.route.queryParams.subscribe(values => {
      if(values.type === 'string'){
        this.selectedTab = this.textSearch_tabIdx;
      }else if(values.type === 'structure' || values.type === 'substructure'){
        this.selectedTab = this.structSearch_tabIdx;
      }
    })
  }

}
